import { render, staticRenderFns } from "./RegistrationsNumbersAdd.vue?vue&type=template&id=4ebfa47a"
import script from "./RegistrationsNumbersAdd.vue?vue&type=script&lang=js"
export * from "./RegistrationsNumbersAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports